import { Injectable } from '@angular/core';
import { AccountService } from '../services/account.service';
import { Observable } from 'rxjs';
import { LookupRequestInfo } from './lookup-grid.component';
import { HttpService } from '../http/http.service';

@Injectable()
export class LookupDialogApi {

  readonly baseUrl: string;
  readonly commonWebApiBaseUrl: string;
  
  private _entityId: number;

  get entityId(): number {
    return this._entityId;
  }

  set entityId(value: number) {
    this._entityId = value;
  }
 
  constructor(private httpService: HttpService, private accountService: AccountService) {
    this.baseUrl = `${this.accountService.baseUrl}/api/LookupDialog_v2/LookupDialog`;    
  }

  getAutocompleteOptions(searchTerm: string, entityId: number, count: number = 10): Observable<any> {
    const searchData = { 'entityId': entityId, 'count': count, 'searchTerm': searchTerm };
    return this.httpService.post(searchData, this.accountService.getUrlExternalBase('AutocompleteOptions', this.baseUrl));
  }

  getRecords(pageInfo: LookupRequestInfo) {    
    switch (pageInfo.entityType) {
      // Uncomment these when start working with common web:
      //case CrmEntityTypeEnum.Contact:
      //return this.httpService.post(this.commonWebApiBaseUrl + 'contact/search', null, this.getHttpHeader());
      //case CrmEntityTypeEnum.Lead:
      //return this.httpService.post(this.commonWebApiBaseUrl + 'lead/search', null, );      
      default:
        let queryParams = `&pageType=${pageInfo.pageType}&pageSize=${pageInfo.pageSize}&currentPageIndex=${pageInfo.currentPageIndex}&` +
          `entityViewId=${pageInfo.entityViewId}`;

        if (pageInfo.entitySubType) {
          queryParams += `&entitySubType=${pageInfo.entitySubType}`;
        }
        if (pageInfo.filter) {
          queryParams += `&filter=${pageInfo.filter}`;
        }
        if (pageInfo.refresh) {
          queryParams += `&refresh=${pageInfo.refresh}`;
        }
        if (pageInfo.isDescendingSort) {
          queryParams += `&isDescendingSort=${pageInfo.isDescendingSort}`;
        }
        if (pageInfo.sortColumnName) {
          queryParams += `&sortColumnName=${pageInfo.sortColumnName}`;
        }
        if (pageInfo.editorType) {
          queryParams += `&editorType=${pageInfo.editorType}`;
        }

        return this.httpService.get(this.accountService.getUrlExternalBase('GetRecords', this.baseUrl) + queryParams);
    }    
  }

  getEntityViews(pageInfo: LookupRequestInfo) {
    let queryParams = `&pageType=${pageInfo.pageType}`;
    if (pageInfo.entitySubType) {
      queryParams += `&entitySubType=${pageInfo.entitySubType}`;
    }

    if (pageInfo.includeLookupViews) {
      queryParams += '&includeLookupViews=true';
    } else {
      queryParams += '&includeLookupViews=false';
    }

    if (pageInfo.editorType) {
      queryParams += `&editorType=${pageInfo.editorType}`;
    }


    return this.httpService.get(this.accountService.getUrlExternalBase('GetEntityViews', this.baseUrl) + queryParams);
  }
}




